import { useState } from "@hookstate/core";
import { state } from "./state";

export const useConfirmPortfolioProjectDeletion = () => {
  return useState(state.confirmPortfolioProjectDeletion);
};
